/**
 *
 * Footer
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import cs from 'classnames';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import mundo from './mundoformas.svg';
import globo from './globo.png';
import sombra from './sombra-globo.png';
import mevueloBlanco from './mevuelo-blanco.svg';
import isoTO from './isoTravelOnux.png';
import copyTO from './letrasTravelOnux.png';
import * as COLORS from 'Constants/colors';

import Modal from 'Components/Modal';
import Icon from 'Components/Icon';
import { Link } from '@reach/router';
import { routes, footerCountryData } from 'Constants';
import TermsAndConditions from 'Components/TermsAndConditions';
// import PoliticsAndPrivacy from '../../components/PoliticsAndPrivacy';
import ModalPoliticsAndPrivacy from 'Components/ModalPoliticsAndPrivacy';
import Text from 'Components/Text';
import Select from 'Components/Select';
import visaLogo from '../../../../Assets/images/visaLogo.png';
import masterLogo from '../../../../Assets/images/masterLogo.png';
import amexLogo from '../../../../Assets/images/amexLogo.png';
import pciDss from '../../../../Assets/images/pci.png';
import banksPayment from '../../../../Assets/images/mv-payment-bank.png';
import cardPayment from '../../../../Assets/images/mv-payment-creditcard.png';
import localPayment from '../../../../Assets/images/mv-payment-multi.png';
import redesPayment from '../../../../Assets/images/mv-payment-reddepagos.png';
import whatsAppLogo from '../../../../Assets/images/whatsapp-32.png';

const selector = ({ appConfiguration, router }) => ({
  sites: appConfiguration.sites,
  pathname: router.location.pathname
});

const Footer = ({ className }) => {
  const dispatch = useDispatch();
  const routing = routes;
  const { sites, pathname } = useSelector(selector);
  const sitesDefault = sites.filter(item => item.enable === true);

  const [showPaP, setshowPaP] = useState(false);

  const [showTaC, setShowTaC] = useState(false);

  const go = route => () => {
    dispatch(push(route));
  };

  const data = footerCountryData();

  const onShowPaP = () => {
    // event && event.preventDefault();

    setshowPaP(old => !old);
  };

  const pushToSocialNetwork = network => () => {
    switch (network) {
      case 'facebook':
        window.open(data.facebook);
        break;

      case 'instagram':
        window.open(data.instagram);
        break;

      case 'linkedin':
        window.open(data.linkedin);
        break;

      case 'whatsapp':
        window.open(data.whatsapp);
        break;

      default:
        break;
    }
  };

  const onShowTaC = event => {
    event && event.preventDefault();

    setShowTaC(old => !old);
  };

  {
    /*
  MVFE-926 Prevent of rendering on checkout
  No borrar este test, sin hablar con Seba
  */
  }

  return /checkout/.test(pathname) || /newCheckout/.test(pathname) ? null : (
    <div className={cs(className)}>
      <div className="manchas-bkg"></div>
      <div className="spinning-wolrd" />
      <div className="globo" />
      <div className="sombra" />
      <div className="content">
        <div className="rowFlex">
          {data.phone && (
            <div className="contentBlock">
              <Icon name="mv-phone" color="white" size={20} />
              <div className="bold-text marginTopText">LLAMANOS</div>
              <div>
                <Link
                  className="white-text"
                  to="#"
                  onClick={e => {
                    window.location = `tel:${data.phone}`;
                    e.preventDefault();
                  }}>
                  {data.phone}
                </Link>
              </div>
            </div>
          )}

          <div className="contact-data">
            <div className="contentBlock social">
              <Icon
                color="white"
                size={32}
                name="mv-facebook-square"
                onClick={pushToSocialNetwork('facebook')}
              />
              <Icon
                color="white"
                size={32}
                name="mv-twitter-square"
                onClick={pushToSocialNetwork('linkedin')}
              />
              <Icon
                color="white"
                size={32}
                name="mv-instagram-square"
                onClick={pushToSocialNetwork('instagram')}
              />
              {data.whatsapp && (
                <img
                  src={whatsAppLogo}
                  onClick={pushToSocialNetwork('whatsapp')}
                  className="icon"
                />
              )}
              {/* TODO: Precisamos tener el logo de whatsApp como un icono asi no tenemos que hacerlo asi */}
            </div>

            <Link
              className="bold-text marginTopText"
              to="#"
              onClick={e => {
                window.location = `mailto:${data.mail}`;
                e.preventDefault();
              }}>
              {data.mail}
            </Link>
          </div>

          {data.address && (
            <div className="contentBlock">
              <Icon name="mv-location-2" color="white" size={20} />
              <div className="bold-text marginTopText">VISITANOS</div>
              <div>{data.address}</div>
            </div>
          )}
        </div>

        <div className="lastBox">
          <div className="bold-text">AGENCIA DE VIAJES REGISTRADA:</div>
          <div className="registro">
            <div>{data.sociedad}</div>
            <div
              onClick={() =>
                window.open(data.validationLink, '_blank', 'noopener')
              }>
              {data.qr && <img src={data.qr} alt="qr" className="qr" />}
            </div>
            <div>
              <img
                src={data.imagen}
                alt="habilitacion"
                className="imagenLogo"
              />
            </div>
          </div>
          <div className="paymentMethods">
            <div className="bold-text payment-title">Formas de pago</div>
            <div className="content-box">
              <div className="paymentsItems">
                <span className="paymentIcon">
                  <img src={banksPayment} alt="transferencia bancaria" />
                </span>
                <Text context="white" size="small" alignment="center">
                  Transferencia bancaria
                </Text>
              </div>
              <div className="paymentsItems">
                <span className="paymentIcon">
                  <img src={cardPayment} alt="tarjetas de credito" />
                </span>
                <Text context="white" size="small" alignment="center">
                  Tarjetas de crédito
                </Text>
              </div>
              <div className="paymentsItems">
                <span className="paymentIcon">
                  <img src={localPayment} alt="pago en el local" />
                </span>
                <Text context="white" size="small" alignment="center">
                  Pago en el local
                </Text>
              </div>
              <div className="paymentsItems">
                <span className="paymentIcon">
                  <img src={redesPayment} alt="redes de cobranza" />
                </span>
                <Text context="white" size="small" alignment="center">
                  Redes de cobranza
                </Text>
              </div>
            </div>
          </div>
          <div className="creditCardPayments">
            <div className="bold-text payment-title">Tarjetas aceptadas</div>
            <div className="white-box">
              <img src={data.imagenCard} alt="card" className="imagenCard" />
              <img src={visaLogo} alt="visa" className="imagenCard" />
              <img src={masterLogo} alt="mastercard" className="imagenCard" />
              <img
                src={amexLogo}
                alt="american express"
                className="imagenCard"
              />
              <img src={pciDss} alt="pci dss compilant" className="pciLogo" />
            </div>
          </div>
        </div>

        <div className="rowFlex">
          <div className="contentBlock mevueloTeam">
            <div className="bold-text">MEVUELO.COM</div>
            <div onClick={go('sobre-nosotros')}>
              <Link
                to={routing.whoWeAre}
                className="footerLink"
                rel="noopener noreferrer">
                SOBRE NOSOTROS
              </Link>
            </div>
            <div>
              <a
                className="footerLink"
                target="_blank"
                rel="noopener noreferrer"
                href="https://talento.mevuelo.com/">
                SUMATE AL EQUIPO
              </a>
            </div>
            <div>
              <a
                className="footerLink"
                target="_blank"
                rel="noopener noreferrer"
                href="/corporativo">
                VIAJES CORPORATIVOS
              </a>
            </div>
            {/* <div>
              <a
                className="footerLink"
                target="_blank"
                rel="noopener noreferrer"
                href="/agarra-vuelo-con-lg">
                AGARRA VUELO CON LG
              </a>
            </div> */}
          </div>

          <div className="contentBlock compraTranquilo">
            <div className="bold-text">COMPRÁ TRANQUILO</div>
            <div onClick={onShowTaC} className="like-link">
              TÉRMINOS Y CONDICIONES
            </div>
            <ModalPoliticsAndPrivacy showPaP={showPaP} onShowPaP={onShowPaP} />
          </div>

          <div className="contentBlock engines">
            <div className="bold-text">LO QUE QUIERAS</div>
            <div>VUELOS</div>
            <div>HOTELES</div>
            <div>PAQUETES</div>
          </div>
        </div>

        {sites && sites.length > 0 && (
          <div className="content-sites">
            <Text context="white" weight="bold" className="title-select">
              SITIO DE:
            </Text>
            <Select
              className="item-inline"
              selectedValue={sitesDefault[0]?.id}
              onSelect={item => window.open(item.id, '_blank', 'noopener')}
              items={sites}
            />
          </div>
        )}

        <div>
          <Text context="white" weight="bold">
            mevuelo.com está presente en:
          </Text>
          <br></br>
          <Text context="white">Uruguay, Paraguay, Bolivia y Colombia</Text>
        </div>

        <div className="rowFlex lastRow">
          <div className="contentBlock">
            <img src={mevueloBlanco} alt="mevuelo" />
          </div>

          <div className="contentBlock">
            <div className="copyright">
              Copyright © {new Date().getFullYear()} Mevuelo.com. Todos los derechos reservados.{' '}
            </div>
          </div>

          <div
            className="contentBlock icon"
            onClick={() =>
              window.open('https://www.travelonux.com/', '_blank', 'noopener')
            }>
            <img src={isoTO} alt="isoTO" />
            <img src={copyTO} alt="copyTO" />
          </div>
        </div>
      </div>
      <Modal
        show={showTaC}
        className="tac-modal"
        closeButton={{ onClick: () => onShowTaC() }}
        header="TÉRMINOS y CONDICIONES"
        onClickOverlay={onShowTaC}
        size="large"
        headerCentered>
        <TermsAndConditions />
      </Modal>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string.isRequired
};

export default styled(Footer)`
  ${({ theme }) => css`
    display: 'block';
    min-height: 883px;
    position: relative;
    overflow: hidden;
    background-image: ${COLORS.gradientHomeMulti};
    font-family: Montserrat, serif;
    font-size: 12.5px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.28;
    letter-spacing: 0.13px;
    text-align: center;
    color: ${COLORS.white};

    .like-link {
      cursor: pointer;
    }

    .icon {
      cursor: pointer;
    }

    .marginTopText {
      margin-top: ${theme.spacing.four};
    }

    .contact-data {
      display: inline-grid;
    }

    .bold-text {
      font-size: 12.5px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 0.56;
      letter-spacing: 0.13px;
      color: ${COLORS.white};
      margin-bottom: ${theme.spacing.two};
    }

    .white-text {
      color: ${COLORS.white};
    }

    .content {
      margin-top: 150px;
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .lastBox {
        margin-top: ${theme.spacing.six};

        .registro {
          display: flex;
          flex-wrap: wrap;
          align-items: baseline;
          justify-content: center;
          padding-bottom: ${theme.spacing.four};

          .imagenLogo {
            margin-left: ${theme.spacing.five};
            height: 43px;
          }

          .qr {
            height: 107px;
            margin: 20px;
          }
        }

        .paymentMethods {
          margin-top: ${theme.spacing.six};

          .payment-title {
            font-size: 15px;
            letter-spacing: 0;
            line-height: 1.2;
            margin-bottom: ${theme.spacing.three};
            text-transform: none;
          }

          .content-box {
            display: flex;
            justify-content: center;
            padding-bottom: ${theme.spacing.four};
            padding-top: ${theme.spacing.two};
            flex-wrap: wrap;
            margin-left: ${theme.spacing.two};
            margin-right: ${theme.spacing.two};
            align-items: stretch;
            @media screen and (min-width: 1330px) {
              min-width: 700px;
              justify-content: space-between;
            }
            .paymentsItems {
              background: rgba(255, 255, 255, 0.08);
              border: 1px solid rgba(255, 255, 255, 0.14);
              border-radius: ${theme.spacing.three};
              display: flex;
              margin-left: ${theme.spacing.two};
              margin-right: ${theme.spacing.two};
              min-height: 118px;
              padding: ${theme.spacing.three};
              font-size: 12px;
              flex-flow: wrap;
              max-width: 120px;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              vertical-align: middle;

              .paymentIcon {
                align-items: center;
                background: rgba(255, 255, 255, 0.12);
                border-radius: 999px;
                display: flex;
                height: 54px;
                justify-content: center;
                margin-bottom: ${theme.spacing.two};
                width: 54px;
              }

              img {
                max-height: 34px;
                max-width: 38px;
              }

              span:not(.paymentIcon) {
                font-size: 12px;
                font-weight: 600;
                line-height: 1.25;
                text-transform: none;
              }
            }
          }
        }

        .creditCardPayments {
          margin-top: ${theme.spacing.six};
          padding-bottom: ${theme.spacing.six};

          .payment-title {
            font-size: 15px;
            letter-spacing: 0;
            line-height: 1.2;
            text-transform: none;
          }

          .white-box {
            margin-top: ${theme.spacing.four};
            border-radius: ${theme.spacing.two};
            display: flex;
            justify-content: space-evenly;
            padding: ${theme.spacing.two};
            flex-wrap: wrap;
            margin-left: auto;
            margin-right: auto;
            max-width: 520px;

            .imagenCard {
              background: ${COLORS.white};
              border-radius: ${theme.spacing.two};
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
              margin: ${theme.spacing.one};
              max-height: 44px;
            }
            .pciLogo {
              height: 45.71px;
              margin: ${theme.spacing.one};
            }
          }
        }
      }

      .content-sites {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        flex: 1 1 auto;
        margin-bottom: ${theme.spacing.ten};

        .mv-select {
          width: 220px;
        }

        span.title-select {
          margin: ${theme.spacing.two};
        }

        @media all and (max-width: 560px) {
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .contentBlock {
      width: 300px;

      .footerLink {
        text-decoration: none;
        color: ${COLORS.white};
      }
    }

    .rowFlex {
      display: flex;
      margin-bottom: ${theme.spacing.eight};
      margin-top: ${theme.spacing.four};

      &.lastRow {
        align-items: flex-end;
      }
    }

    .social {
      display: flex;
      justify-content: space-evenly;
      align-items: flex-end;
    }

    .spinning-wolrd {
      width: 800px;
      height: 800px;
      background-image: url(${mundo});
      position: absolute;
      top: 100%;
      margin-top: -357px;
      left: 0;
      margin-left: -304px;
      animation-name: infinite-spinning;
      animation-duration: 100s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }

    .sombra {
      width: 66px;
      height: 20px;
      background-image: url(${sombra});
      top: 100%;
      margin-top: -144px;
      left: 137px;
      position: absolute;
      background-size: contain;
      animation-name: footer-shadow-movement;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-timing-function: ease;
    }

    .globo {
      width: 117px;
      height: 153px;
      background-image: url(${globo});
      position: absolute;
      top: 100%;
      margin-top: -286px;
      left: 134px;
      animation-name: baloon-movement;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-timing-function: ease;
    }

    .copyright {
      font-family: Montserrat, serif;
      font-size: 6.5px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.38;
      letter-spacing: normal;
      color: ${COLORS.white};
    }

    @media screen and (max-width: 1240px) {
      min-height: 924px;

      .spinning-wolrd {
        left: 50%;
        margin-left: -400px;
        margin-top: -282px;
        background-color: transparent;
      }

      .globo {
        left: 50%;
        margin-left: -42px;
        animation-name: baloon-movement_centered;
      }

      .sombra {
        animation-name: footer-shadow-movement_centered;
        left: 50%;
        margin-left: -40px;
        margin-top: -106px;
      }

      .rowFlex {
        &.lastRow {
          margin-bottom: 335px;
        }
      }
    }

    @media screen and (max-width: 790px) {
      min-height: auto;
      padding: ${theme.spacing.eight} ${theme.spacing.four}
        ${theme.spacing.twelve};

      .spinning-wolrd,
      .globo,
      .sombra {
        display: none;
      }

      .content {
        margin-top: 0;
      }

      .rowFlex {
        flex-direction: column;
        align-items: center;
        margin-bottom: ${theme.spacing.four};
        margin-top: 0;

        &.lastRow {
          align-items: center;
          margin-bottom: 0;
        }
      }

      .contentBlock {
        margin: ${theme.spacing.two} 0;
        width: 100%;
        max-width: 320px;

        &.mevueloTeam {
          display: block;

          a:link {
            text-decoration: none;
          }
        }

        &.compraTranquilo {
          display: none;
        }

        &.engines {
          display: none;
        }
      }

      .contact-data {
        margin: ${theme.spacing.three} 0;
      }

      .marginTopText {
        margin-top: ${theme.spacing.two};
      }

      .bold-text {
        line-height: 1.2;
        margin-bottom: ${theme.spacing.two};
      }

      .content {
        .lastBox {
          margin-top: ${theme.spacing.four};

          .registro {
            align-items: center;
            padding-bottom: ${theme.spacing.two};

            .qr {
              height: 82px;
              margin: ${theme.spacing.two};
            }

            .imagenLogo {
              height: 36px;
              margin-left: ${theme.spacing.two};
            }
          }

          .paymentMethods {
            margin-top: ${theme.spacing.four};

            .payment-title {
              font-size: 16px;
              margin-bottom: ${theme.spacing.three};
            }

            .content-box {
              display: grid;
              grid-template-columns: repeat(2, minmax(128px, 1fr));
              gap: ${theme.spacing.two};
              margin: 0 auto;
              max-width: 320px;
              padding: 0 0 ${theme.spacing.three};

              .paymentsItems {
                margin: 0;
                min-height: 112px;
                max-width: none;
                padding: ${theme.spacing.three} ${theme.spacing.two};

                .paymentIcon {
                  height: 50px;
                  margin-bottom: ${theme.spacing.two};
                  width: 50px;
                }

                img {
                  max-height: 32px;
                  max-width: 36px;
                }
              }
            }
          }

          .creditCardPayments {
            margin-top: ${theme.spacing.four};
            padding-bottom: ${theme.spacing.four};

            .payment-title {
              font-size: 16px;
            }

            .white-box {
              align-items: center;
              gap: ${theme.spacing.two};
              justify-content: center;
              margin: ${theme.spacing.three} auto 0;
              max-width: 320px;
              padding: ${theme.spacing.three};
              border-radius: ${theme.spacing.three};

              .imagenCard {
                max-height: 42px;
                margin: 0;
              }

              .pciLogo {
                height: 38px;
                margin-top: 0;
              }
            }
          }
        }

        .content-sites {
          margin-bottom: ${theme.spacing.four};
        }
      }
    }

    @media screen and (max-width: 450px) {
      padding-bottom: ${theme.spacing.twelve};

      .content {
        .lastBox {
          .registro {
            .imagenLogo {
              margin-top: ${theme.spacing.three};
              margin-left: 0px;
            }
          }

          .creditCardPayments {
            .white-box {
              .pciLogo {
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  `}
`;
